<template>
  <div class="h-100">

    <!-- BEGIN MODALS -->
    <b-modal
      id="api-err-modal"
      v-model="rowEditModalShow"
      centered
      scrollable
      :header-bg-variant="'dark'"
      :header-text-variant="'light'"
      title="Edit Mosquito"
      hide-footer
    >
    <!-- hide-footer -->
      <b-row class="mt-2">
        <b-col class="font-weight-bold col-6">
          Mosquito Code:
        </b-col>
        <b-col>
          <b-form-input
            v-model="selected_mosquito['mosquito_code']"
            disabled
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col class="font-weight-bold col-6">
          Species:
        </b-col>
        <b-col>
          <b-select v-model="selected_mosquito['species']" :options="species"></b-select>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col class="font-weight-bold col-6">
          Sex:
        </b-col>
        <b-col>
          <b-select v-model="selected_mosquito['sex']" :options="['Female', 'Male', 'Unknown']"></b-select>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col class="font-weight-bold col-6">
          Abdominal Status:
        </b-col>
        <b-col>
          <b-select v-model="selected_mosquito['abdominal_status']" :options="abdominal_statuses"></b-select>
        </b-col>
      </b-row>
      <hr>
      <b-row v-if="selected_mosquito['new_row']">
        <b-col class="float-right text-right">
          <b-button class="mt-3" @click="rowEditModalShow=false">Cancel</b-button>
          <b-button class="mt-3 ml-2" variant='primary' @click="createNewMosquito">Create new record</b-button>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col class="float-right text-right">
          <b-button class="mt-3" @click="rowEditModalShow=false">Cancel</b-button>
          <b-button class="mt-3 ml-2" variant='danger' @click="deleteMosquitoModalShow = true">Delete</b-button>
          <b-button class="mt-3 ml-2" variant='primary' @click="saveMosquitoRecord">Save</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
        id="delete-mosquito-modal"
        v-model="deleteMosquitoModalShow"
        centered
        size="lg"
        scrollable
        title="Confirm Mosquito Record Deletion"
        ok-title="Yes, Delete"
        @ok="deleteMosquitoRecord"
        :header-bg-variant="'danger'"
        :header-text-variant="'light'">
        <!-- <p class="my-4">{{modalText}}</p> -->
        <span v-html="'Are you sure you want to delete this mosquito record?'"></span>
        <form ref="form" @submit.stop.prevent="handleSubmit">
      </form>
    </b-modal>
    <b-modal
        id="download-mosquito-data-modal"
        v-model="downloadMosquitoDataModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="Downloading Mosquito Data"
        :header-bg-variant="'dark'"
        :header-text-variant="'light'">
        <p class="my-4">Please wait while we fetch your file.</p>
    </b-modal>
    <b-modal
        id="error-modal"
        v-model="errorModalShow"
        centered
        scrollable
        title="Error"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <p class="my-4">There was a problem downloading your file.</p>
    </b-modal>
    <b-modal
        id="request_report_modal"
        size="lg"
        title="Request Report"
        :ok-title="'Submit'"
        @ok="download_live"
    >
        <p>
            A CSV report will be generated, and
            a link will be sent to your email address to download once it is ready.
        </p>
        <hr />
        <p>
            Send link to:
            <b-form-input
                v-model="report_email"
                placeholder="youremail@someplace.com"
            ></b-form-input>
        </p>
    </b-modal>
    <!-- END MODALS -->

    <b-container fluid>
      <b-row>
        <b-col>
          <h2 class="tw-mb-0 text-aegis-dk">
            Process New Collection 
            <b-badge>{{collection_code}}</b-badge>
          </h2>
          <p class="tw-italic tw-text-gray-700">
            Select a collection code and add counts of mosquitos collected.
          </p>
        </b-col>
        <b-col cols="auto" v-if="ento_lead">
          <b-button
            @click="request_report()"
            variant="success"
            class="px-5"
            size="lg"
          >
            Download All Mosquito Data
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid v-if="collection_code == null">
      <b-row>
        <b-col>
          <b-form-input
            label="Collection Code"
            placeholder="Collection Code"
            v-model="search_code"
            size="lg"
            @keypress.enter="checkCollectionCode()"
            @click:append="checkCollectionCode()"
          ></b-form-input>
        </b-col>
        <b-col cols="auto">
          <b-button @click="checkCollectionCode()" block size="lg" variant="success">
            Search Code
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <hr />

    <!-- BEGIN ENTRY MATRIX -->
    <b-card v-if="collection_code!=null && ento_data.length==0">
      <h3>Collection Code: {{ collection_code }}</h3>
      <b-row>
        <b-col class="tw-p-2 grid-column">Species</b-col>
        <b-col v-for="heading in headings" :key="heading" class="tw-p-2 grid-column">{{ heading }}</b-col>
      </b-row>
      <span v-for="(row, r_index) in chunks" :key="row.key">
        <b-row>
          <b-col class="tw-p-2 grid-column">{{ species[r_index] }}</b-col>
            <b-col class="tw-p-2 grid-column" v-for="col in row" :key="col.key">
              <!-- Need to add the :key to the total fields to force them to rerender when updating. -->
              <!-- Can't add them to all fields or they lose focus on rerender.-->
              <b-form-input v-if="col.includes('total')"
                v-model="form_vars[col]"
                required
                :title="col"
                :disabled="isDisabled(col)"
                :key="inputKey"
              ></b-form-input>
              <!-- On the rest of the fields, add an event handler to total the fields -->
              <b-form-input v-else
                v-model="form_vars[col]"
                required
                :title="col"
                :disabled="isDisabled(col)"
                @keyup="calcTotal(species[r_index])"
              ></b-form-input>
          </b-col>
        </b-row>
      </span>

      <div class="text-center tw-mt-4">
        <!-- <b-btn variant="outline-primary" class="tw-mx-1">Clear</b-btn> -->
        <b-btn variant="primary" class="tw-mx-1" @click="save()"
          >Save</b-btn>
      </div>
    </b-card>
    <!-- END ENTRY MATRIX -->

    <!-- BEGIN ENTO TABLE -->
    <b-card v-if="ento_data.length>0">
      <b-row>
        <b-col>
          <!-- <small>Total mosquitos: {{ totalRows }} <i @click="download(collection_code)" class="fa fa-download text-success" v-b-modal.report-modal style="margin-left: 10px; cursor: pointer;" title="Download Collection Data"></i></small> -->
          <small>Total mosquitos: {{ totalRows }}</small>
          <b-button
            @click="download(collection_code)"
            variant="success"
            class="px-5 ml-2"
            size="lg"
            :disabled="collection_code == ''"
            v-if="ento_lead"
          >
            Download {{ collection_code }} Data
          </b-button>
        </b-col>
        <b-col cols="auto" v-if="ento_lead">
          <b-button
            @click="getNextMosquito"
            variant="success"
            class="mb-2 px-5"
            size="lg"
          >
            Add mosquito
          </b-button>
        </b-col>
    </b-row>
    <b-table
      ref="table"
      striped
      hover
      responsive
      :items="ento_data"
      :fields="fields"
      :busy.sync="loading"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @row-clicked="handleRowClick"
    >
    </b-table>
    <h3 v-if="ento_lead==false" style="text-align: center;">This collection has been entered. If changes are needed to submitted data, please contact a supervisor.</h3>
  </b-card>
  <!-- END ENTO TABLE -->

  </div>
</template>

<script>
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapState, mapGetters, mapActions } from "vuex";

import { HTTP } from "@/utilities/http-common";
// import HandleErrors from '@/utilities/handle-errors';

import * as _ from "lodash";

export default {
  mixins: [DashboardBaseTemplate],
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      message: null,
      search_code: null,
      collection_code: null,
      species: [
        "Aedes aegypti",
        "Aedes albopictus",
        "Aedes vittatus",
        "Armigeres spp.",
        "Culex spp.",
        "Anopheles spp.",
        "Other",
        "Unknown"
      ],
      headings: [
        'Unfed',
        'Partially Fed',
        'Fed',
        'Gravid',
        'Male',
        'Unknown',
        'Total'
      ],
      na_string: 'N/A',   // Whatever we want to say on the un-needed inputs
      inputKey:0,         // Used to force re-render of page components
      form_vars: {},      // Contains key/val pairs built dynamically. The resulting is alphabetized unfortunately...
      form_key_list: [],  // This is just a list of key names from form_vars, but in a defined order
      fields: [
        'mosquito_code',
        'collection_date',
        'species',
        'sex',
        'abdominal_status',
        // 'status',
        'last_modified_by',
        'last_modified_date'
      ],
      ento_data: [],      // Will contain table data
      // options: {
      //   currentPage: 1,
      //   totalRows: 10,
      //   perPage: 20
      // },
      totalRows: 0,
      sortBy: "id",
      sortDesc: false,
      loading: false,
      rowEditModalShow: false,
      selected_mosquito: {},
      downloadMosquitoDataModalShow: false,
      deleteMosquitoModalShow: false,
      errorModalShow: false,
      deleteConfirmed: false,
      deleteConfirmState: null,
    };
  },
  created(){
    this.unpackUrlQueryParams(this.$route.query);
  },
  mounted: function() {
    this.getEntoData(this.collection_code);
    this.buildFormVars();
  },
  computed: {
    ...mapState("websheet", ["newEntoCollectionModal", "entoCollectionCodes"]),
    ...mapGetters("websheet", ["getCodes"]),
    ...mapGetters('user', ['inMyGroups']),
    chunks:function () {
      return _.chunk(this.form_key_list, this.headings.length);
    },
    abdominal_statuses:function () {
      var options = [];
      _.forEach(this.headings, (field) => {
        if (field != 'Total') {
          options.push(field);
        }
      });
      options.push('N/A');
      return options
    },
    ento_lead: function() {
      if (this.inMyGroups(['Ento Lead'])) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {},
  methods: {
    checkCollectionCode() {
      const fd = new FormData();

      fd.append('collection_code', this.search_code);

      HTTP.post("/srilanka/check_collection_code/", fd)
      .then(response => {
        this.$notify({
          text: response.data.message,
          duration: 10000,
          type: "success",
        });
        this.collection_code = this.search_code;
        this.search_code = null;
        this.buildFormVars();
        this.getEntoData(this.collection_code);
      })
      .catch((error) => {
        if ("message" in error.response.data) {
          this.message = error.response.data["message"];
          this.$notify({
            text: error.response.data["message"],
            duration: 10000,
            type: "error",
          });
        }
      });
    },
    getEntoData: function (code=null) {
      if(!this.collection_code.trim()) {
        return;
      }
      let params = {}
      params.collection_code = code;
      HTTP.get('/srilanka/list-mosquito-data', {
        params: params
      }).then(response => {
        this.ento_data = response.data.row_data;
        this.totalRows = response.data.totalRows
      });
    },
    save: function() {
      let that = this;

      // We shouldn't ever need this, but it's here to be safe.
      that.message = null;
      if (!that.collection_code) {
        this.$notify({
          text: "Please select a collection code!",
          duration: 10000,
          type: "error",
        });
        return;
      }

      // build the params.
      var params = new URLSearchParams();

      params.append('collection_code', that.collection_code);

      // look at the form_vars and pull out any that aren't NA
      _.forEach(Object.keys(this.form_vars), (field) => {
        if (this.form_vars[field] != this.na_string) {
          params.append(field, this.form_vars[field]);
        }
      });

      HTTP.post("/srilanka/process-new-ento-collection/", params)
        .then(() => {
          this.getEntoData(that.collection_code);
          
        })
        .catch((error) => {
          if ("message" in error.response.data) {
            that.message = error.response.data["message"];
          }
        });
    },
    download: function () {
      this.downloadMosquitoDataModalShow = true;
      // Call the backend to generate the file and get the filename
      HTTP.get('/srilanka/generate-mosquito-csv')
        .then(response => {
          this.downloadMosquitoDataModalShow = false;
          const filename = response.data.filename;
          // Trigger the browser to download the file
          window.open(`${process.env.VUE_APP_AXIOS_BASE_URL}/srilanka/download/${filename}`, '_blank');
        })
        .catch(error => {
          this.downloadMosquitoDataModalShow = false;
          this.errorModalShow = true;
        });
    },
    download_live: function () {
        let that = this;
        let request_string =
            "/srilanka/ento-report/request-report?" +
            "&email=" +
            that.report_email

        // if (that.start_date != null) {
        //     request_string += "&start_date=" + that.start_date;
        // }
        // if (that.end_date != null) {
        //     request_string += "&end_date=" + that.end_date;
        // }
        // if (that.study_phase != null) {
        //     request_string += "&study_phase=" + that.study_phase
        // }

        HTTP.get(request_string)
            .then((response) => {
                alert("A report will be emailed to you shortly.");
            })
            .catch((error) => {
                HandleErrors.HandleErrors(error);
                that.historic_download_in_progress = false;
            });
    },
        request_report: function() {
            this.$bvModal.show('request_report_modal');
        },
    buildFormVars() {
      _.forEach(this.species, (speciesItem) => {
        const speciesName = _.lowerCase(speciesItem).replace(/ /g, '_');
        
        _.forEach(this.headings, (headingItem) => {
          const headingName = _.lowerCase(headingItem).replace(/ /g, '_');
          const variableName = `${speciesName}-${headingName}`;

          // We only care about values for the "aegypti", "albopictus" or "Total" fields.
          if (speciesName.includes("aegypti") || speciesName.includes("albopictus") || headingName.includes("total")) {
            this.form_vars[variableName] = 0;
          } else {
            this.form_vars[variableName] = this.na_string;
          }
          // form_vars is going to be alphabetized... We need an array to keep the order for us:
          this.form_key_list.push(variableName);
        });
      });
    },
    isDisabled(field_name) {
      if (this.form_vars[field_name]==this.na_string || field_name=='aedes_aegypti-total' || field_name=='aedes_albopictus-total') {
        return true;
      } else if (this.collection_code == '') {
        return true;
      }
      return false;
    },
    calcTotal(species) {
      // build field_list to be added using species and column headings
      let field_list = [];
      for (let i = 0; i < this.headings.length; i++ ) {
        field_list.push(_.lowerCase(species).replace(/ /g, '_') + '-' + _.lowerCase(this.headings[i]).replace(/ /g, '_'));
      }

      // remove the last field name. It'll be the name of the total field so we don't want it in the sum
      // but we do want the name of it so that we can use it to assign the value to form_vars
      let species_total_fieldname = field_list.pop()

      let total = 0;
      _.forEach(field_list, (field) => {
        total += parseInt(this.form_vars[field]);
      });
      this.inputKey++;
      this.form_vars[species_total_fieldname] = total;
    },
    unpackUrlQueryParams(query_obj){
      if ("collectionCode" in query_obj) {
        // alert(query_obj.collectionCode)
        this.collection_code = query_obj.collectionCode;
        // alert(query_obj.collectionCode)
        // this.search();
      }
    },
    handleRowClick(record, index){
      if (this.ento_lead) {
        this.rowEditModalShow=true;
        this.selected_mosquito = record;
      } else {
        return;
      }

    },
    saveMosquitoRecord() {
      const fd = new FormData();

      fd.append('mosquito_code', this.selected_mosquito['mosquito_code']);
      fd.append('species', this.selected_mosquito['species']);
      if (this.selected_mosquito['sex'] == 'undefined') {
        fd.append('sex', "Unknown");
      } else {
        fd.append('sex', this.selected_mosquito['sex']);
      }
      if (this.selected_mosquito['abdominal_status'] == 'undefined') {
        fd.append('abdominal_status', "Unknown");
      } else {
        fd.append('abdominal_status', this.selected_mosquito['abdominal_status']);
      }
      fd.append('deleted', false);

      HTTP.post('/srilanka/update-ento/', fd).then(response => {
        this.getEntoData(this.collection_code);
        this.rowEditModalShow = false;
        this.$notify({
          text: response.data.message,
          duration: 10000,
          type: "success",
        });
      });

    },
    deleteMosquitoRecord() {
      const fd = new FormData();

      fd.append('mosquito_code', this.selected_mosquito['mosquito_code']);
      fd.append('deleted', true);

      HTTP.post('/srilanka/update-ento/', fd).then(response => {
        this.getEntoData(this.collection_code);
        this.deleteMosquitoModalShow = false;
        this.rowEditModalShow = false;
      });
    },
    getNextMosquito() {
      this.selected_mosquito = {}
      const fd = new FormData();

      fd.append('collection_code', this.collection_code);

      HTTP.post("/srilanka/get_next_mosquito_code/", fd)
      .then(response => {
        this.selected_mosquito['mosquito_code'] = response.data;
        this.selected_mosquito['new_row'] = true;
        this.rowEditModalShow = true;
      })
      .catch((error) => {
        if ("message" in error.response.data) {
          this.message = error.response.data["message"];
        }
      });
    },
    createNewMosquito() {
      const fd = new FormData();

      fd.append('collection_code', this.collection_code);
      fd.append('mosquito_code', this.selected_mosquito['mosquito_code']);
      if (this.selected_mosquito['sex'] == undefined) {
        fd.append('sex', "Unknown");
      } else {
        fd.append('sex', this.selected_mosquito['sex']);
      }
      if (this.selected_mosquito['abdominal_status'] == undefined) {
        fd.append('abdominal_status', "Unknown");
      } else {
        fd.append('abdominal_status', this.selected_mosquito['abdominal_status']);
      }
      fd.append('species', this.selected_mosquito['species']);
      fd.append('deleted', false);

      HTTP.post("/srilanka/create_new_ento_record/", fd)
      .then(response => {
        this.getEntoData(this.collection_code);
        this.rowEditModalShow = false;
        this.$notify({
          text: response.data.message,
          duration: 10000,
          type: "success",
        });
      })
      .catch((error) => {
        if ("message" in error.response.data) {
          this.message = error.response.data["message"];
          this.$notify({
            text: error.response.data["message"],
            duration: 10000,
            type: "error",
          });
        }
      });
    }
  },
};
</script>

<style>
.grid-column {
  width: 12%;
  /* border: solid black 1px; */
}
</style>
